// extracted by mini-css-extract-plugin
export var clickThrough = "_yv-2";
export var fallback = "_yv-5";
export var frame = "_yv-3";
export var frameCell = "_yv-1";
export var overlay = "_yv-4";
export var wrapper = "_yv-0";